/**
 * Admin Utilities
 * Functions to check if a user is a superadmin
 */

import { supabase } from '../supabase';

// Whitelist of superadmin email addresses
// These users will have all content unlocked in the app
const SUPERADMIN_EMAILS: string[] = [
  // Add your superadmin email addresses here
  // Example: 'your-admin@example.com',
  // Add second email here
  'ronaldoroy666@gmail.com',
  'nahidul6295@gmail.com',
  'ronaldoroy555@gmail.com',

];

/**
 * Check if the current user is a superadmin based on email whitelist
 */
export const isSuperAdmin = async (): Promise<boolean> => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user || !user.email) {
      return false;
    }

    // Check if user email is in superadmin whitelist
    return SUPERADMIN_EMAILS.includes(user.email.toLowerCase());
  } catch (error) {
    console.error('Error checking superadmin status:', error);
    return false;
  }
};

/**
 * Check if an email is a superadmin (sync version for initial checks)
 */
export const isSuperAdminEmail = (email: string | null | undefined): boolean => {
  if (!email) return false;
  return SUPERADMIN_EMAILS.includes(email.toLowerCase());
};

/**
 * Get superadmin status from user session (fast check)
 */
export const getSuperAdminStatus = async (): Promise<boolean> => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session?.user?.email) {
      return false;
    }

    const email = session.user.email.toLowerCase();
    return isSuperAdminEmail(email);
  } catch (error) {
    console.error('Error getting superadmin status:', error);
    return false;
  }
};

